










import {
  defineComponent,
} from '@vue/composition-api';

import CommonFormWithDeliveryFlatRate from '@/components/Delivery/CommonFormWithDeliveryFlatRate.vue';

const CreateOrderFlatRate = defineComponent({
  components: {
    CommonFormWithDeliveryFlatRate,
  },
});

export default CreateOrderFlatRate;
